import { PartialTranslation } from '../translations';

export const kn: PartialTranslation = {
  newChat: 'ಹೊಸ ಚಾಟ್',
  search: 'ಹುಡುಕಿ',
  user: 'ಬಳಕೆದಾರ',
  settings: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
  language: 'ಭಾಷೆ',
  getHelp: 'ಸಹಾಯ ಪಡೆಯಿರಿ',
  viewAllPlans: 'ಎಲ್ಲಾ ಯೋಜನೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
  learnMore: 'ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ',
  logOut: 'ಲಾಗ್ ಔಟ್',
  chooseLanguage: 'ಭಾಷೆ ಆಯ್ಕೆಮಾಡಿ',
  chooseYourPreferredLanguage: 'ನಿಮ್ಮ ಆದ್ಯತೆಯ ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
  searchLanguages: 'ಭಾಷೆಗಳನ್ನು ಹುಡುಕಿ...',
  autoDetect: 'ಸ್ವಯಂಚಾಲಿತ ಪತ್ತೆ',
  noLanguagesFound: 'ಯಾವುದೇ ಭಾಷೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ',
  askAnything: 'ಏನನ್ನಾದರೂ ಕೇಳಿ',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'ವೈಯಕ್ತಿಕ',
  freePlan: 'ಉಚಿತ ಯೋಜನೆ',
  current: 'ಪ್ರಸ್ತುತ',
  close: 'ಮುಚ್ಚಿ',
  archive: 'ಆರ್ಕೈವ್',
  delete: 'ಅಳಿಸಿ',
  confirmDelete: 'ನೀವು ನಿಜವಾಗಿಯೂ ಈ ಚಾಟ್ ಅನ್ನು ಅಳಿಸಲು ಬಯಸುವಿರಾ?',
  confirmArchive: 'ನೀವು ನಿಜವಾಗಿಯೂ ಈ ಚಾಟ್ ಅನ್ನು ಆರ್ಕೈವ್ ಮಾಡಲು ಬಯಸುವಿರಾ?',
  deleteCannotUndo: 'ಈ ಕ್ರಿಯೆಯನ್ನು ರದ್ದುಗೊಳಿಸಲಾಗುವುದಿಲ್ಲ.',
  archiveCanFind: 'ಆರ್ಕೈವ್ ಮಾಡಿದ ನಂತರ ನೀವು ಅದನ್ನು ಆರ್ಕೈವ್ ಪಟ್ಟಿಯಲ್ಲಿ ಕಾಣಬಹುದು.',
  // 资源面板
  resources: 'ಸಂಪನ್ಮೂಲಗಳು',
  addResource: 'ಸಂಪನ್ಮೂಲ ಸೇರಿಸಿ',
  deleteResource: 'ಸಂಪನ್ಮೂಲ ಅಳಿಸಿ',
  noMatchingResourcesFound: 'ಹೊಂದಿಕೆಯಾಗುವ ಸಂಪನ್ಮೂಲಗಳು ಕಂಡುಬಂದಿಲ್ಲ',
  noResourcesAvailable: 'ಯಾವುದೇ ಸಂಪನ್ಮೂಲಗಳು ಲಭ್ಯವಿಲ್ಲ',
  hideResources: 'ಸಂಪನ್ಮೂಲಗಳನ್ನು ಮರೆಮಾಡಿ',
  showResources: 'ಸಂಪನ್ಮೂಲಗಳನ್ನು ತೋರಿಸಿ',
  
  // 聊天输入框
  typeMessage: 'ಸಂದೇಶವನ್ನು ಟೈಪ್ ಮಾಡಿ...',
  thinkingOptions: 'ಚಿಂತನೆಯ ಆಯ್ಕೆಗಳು',
  deleteFile: 'ಫೈಲ್ ಅಳಿಸಿ',
  clearSelection: 'ಆಯ್ಕೆ ತೆರವುಗೊಳಿಸಿ',
  
  // 思考模式选项
  deepInsight: 'ಆಳವಾದ ಒಳನೋಟ · ಮೇಲ್ಮೈ ವಿಶ್ಲೇಷಣೆ',
  deepInsightDesc: 'ಮುಖ್ಯ ಅಂಶಗಳ ತ್ವರಿತ ತಿಳುವಳಿಕೆ',
  deepExploration: 'ಆಳವಾದ ಅನ್ವೇಷಣೆ · ಸಮಗ್ರ ವಿಶ್ಲೇಷಣೆ',
  deepExplorationDesc: 'ಬಹುಆಯಾಮದ ಆಳವಾದ ಸಂಶೋಧನೆ',
  deepDeconstruction: 'ಆಳವಾದ ವಿಘಟನೆ · ವ್ಯವಸ್ಥಿತ ವಾದ',
  deepDeconstructionDesc: 'ಪದರದಿಂದ ಪದರಕ್ಕೆ ಪ್ರಗತಿಶೀಲ ವಿಶ್ಲೇಷಣೆ',
  
  // 写作模式选项
  contractReview: 'ಒಪ್ಪಂದ ಪರಿಶೀಲನೆ · ಅಪಾಯ ಗುರುತಿಸುವಿಕೆ',
  contractReviewDesc: 'ಷರತ್ತು ವಿಶ್ಲೇಷಣೆ ಮತ್ತು ಅನುಸರಣೆ ಪರಿಶೀಲನೆ',
  textPolish: 'ಪಠ್ಯ ಪಾಲಿಶ್ · ವೃತ್ತಿಪರ ಅಭಿವ್ಯಕ್ತಿ',
  textPolishDesc: 'ಭಾಷಾ ಆಪ್ಟಿಮೈಸೇಶನ್ ಮತ್ತು ರಚನೆ ಹೊಂದಾಣಿಕೆ',
  legalDocuments: 'ಕಾನೂನು ದಾಖಲೆಗಳು · ಮಾನದಂಡ ಕರಡು',
  legalDocumentsDesc: 'ವೃತ್ತಿಪರ ಕಾನೂನು ದಾಖಲೆ ಬರವಣಿಗೆ',
  addAttachment: 'ಲಗತ್ತು ಸೇರಿಸಿ',
  sendMessage: 'ಸಂದೇಶ ಕಳುಹಿಸಿ',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'ಲಾಗಿನ್',
  register: 'ನೋಂದಣಿ',
  welcomeBack: 'LawHelper ಗೆ ಸುಸ್ವಾಗತ',
  loginSubtitle: 'ನಿಮ್ಮ AI ಕಾನೂನು ಸಂಶೋಧನಾ ಸಹಾಯಕ',
  continueWithGoogle: 'Google ನೊಂದಿಗೆ ಮುಂದುವರಿಸಿ',
  continueWithMicrosoft: 'Microsoft ನೊಂದಿಗೆ ಮುಂದುವರಿಸಿ',
  continueWithWeChat: 'WeChat ನೊಂದಿಗೆ ಮುಂದುವರಿಸಿ',
  orContinueWith: 'ಅಥವಾ ಇದರೊಂದಿಗೆ ಮುಂದುವರಿಸಿ',
  emailTab: 'ಇಮೇಲ್',
  phoneTab: 'ಫೋನ್',
  emailPlaceholder: 'ನಿಮ್ಮ ಇಮೇಲ್ ನಮೂದಿಸಿ',
  phonePlaceholder: 'ಫೋನ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ',
  codePlaceholder: '6 ಅಂಕಿಯ ಕೋಡ್ ನಮೂದಿಸಿ',
  sending: 'ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ...',
  verifying: 'ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ...',
  verify: 'ಪರಿಶೀಲಿಸಿ',
  sendMagicLink: 'ಮ್ಯಾಜಿಕ್ ಲಿಂಕ್ ಕಳುಹಿಸಿ',
  getVerificationCode: 'ಕೋಡ್ ಪಡೆಯಿರಿ',
  resendCode: 'ಕೋಡ್ ಮತ್ತೆ ಕಳುಹಿಸಿ',
  resendIn: 'ಮತ್ತೆ ಕಳುಹಿಸಿ',
  magicLinkSent: 'ಮ್ಯಾಜಿಕ್ ಲಿಂಕ್ ನಿಮ್ಮ ಇಮೇಲ್‌ಗೆ ಕಳುಹಿಸಲಾಗಿದೆ',
  magicLinkHint: 'ನಿಮ್ಮ ಇಮೇಲ್‌ಗೆ ಸುರಕ್ಷಿತ ಲಿಂಕ್ ಕಳುಹಿಸುತ್ತೇವೆ',
  otpSent: 'ಪರಿಶೀಲನಾ ಕೋಡ್ ಕಳುಹಿಸಲಾಗಿದೆ',
  agreeToTerms: 'ಮುಂದುವರಿಸುವ ಮೂಲಕ, ನೀವು ಒಪ್ಪುತ್ತೀರಿ',
  privacyPolicy: 'ಗೌಪ್ಯತಾ ನೀತಿ',
  termsOfService: 'ಸೇವಾ ನಿಯಮಗಳು',
  and: 'ಮತ್ತು',
  privacyTitle: 'ನಿಮ್ಮ ಗೌಪ್ಯತೆ ಮುಖ್ಯ',
  privacyIntro: 'ಉತ್ತಮ ಅನುಭವ ನೀಡಲು ಕುಕೀಗಳು ಮತ್ತು ಇದೇ ರೀತಿಯ ತಂತ್ರಜ್ಞಾನಗಳನ್ನು ಬಳಸುತ್ತೇವೆ.',
  essentialCookies: 'ಅಗತ್ಯ ಕುಕೀಗಳು',
  essentialDesc: 'ವೆಬ್‌ಸೈಟ್ ಕಾರ್ಯನಿರ್ವಹಿಸಲು ಅಗತ್ಯ',
  analyticsCookies: 'ವಿಶ್ಲೇಷಣಾ ಕುಕೀಗಳು',
  analyticsDesc: 'ಸೇವೆಯನ್ನು ಸುಧಾರಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ',
  marketingCookies: 'ಮಾರ್ಕೆಟಿಂಗ್ ಕುಕೀಗಳು',
  marketingDesc: 'ವೈಯಕ್ತಿಕಗೊಳಿಸಿದ ವಿಷಯಕ್ಕಾಗಿ ಬಳಸಲಾಗುತ್ತದೆ',
  acceptAll: 'ಎಲ್ಲವನ್ನೂ ಸ್ವೀಕರಿಸಿ',
  essentialOnly: 'ಅಗತ್ಯವಾದವುಗಳು ಮಾತ್ರ',
  customize: 'ಕಸ್ಟಮೈಸ್ ಮಾಡಿ',
  savePreferences: 'ಆದ್ಯತೆಗಳನ್ನು ಉಳಿಸಿ',
  back: 'ಹಿಂದೆ',
  readPrivacyPolicy: 'ನಮ್ಮ ಗೌಪ್ಯತಾ ನೀತಿಯನ್ನು ಓದಿ',
  cookiePolicy: 'ಕುಕೀ ನೀತಿ',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI ಪರಿಶೀಲನೆ',
  aiDraft: 'AI ಕರಡು',
  smartAssistant: 'ಟೆಂಪ್ಲೇಟ್',

  // 知识库搜索
  enableKnowledgeSearch: 'ಹುಡುಕಾಟ ಸಕ್ರಿಯಗೊಳಿಸಿ',
  knowledgeSearchDesc: 'AI ನಿಮ್ಮ ದಾಖಲೆಗಳಲ್ಲಿ ಹುಡುಕುತ್ತದೆ',
  clickToDisable: 'ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಿ',
  clickToEnable: 'ಸಕ್ರಿಯಗೊಳಿಸಿ',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'ತ್ವರಿತ ಉತ್ತರ',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'ರದ್ದುಮಾಡಿ',
  library: 'ಗ್ರಂಥಾಲಯ',
  filterAll: 'ಎಲ್ಲ',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'ಯೋಚಿಸುತ್ತಿದ್ದೇನೆ...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'ಸಾಮಾನ್ಯ',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'ಕುರಿತು',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'ಸ್ಮಾರ್ಟ್ ದಸ್ತಾವೇಜು ಸಹಾಯಕ',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'ದೋಷ',
  unknownError: 'Unknown error',
  file: 'ಫೈಲ್',
  loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI ವಿಶ್ಲೇಷಣೆ',
};
